/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")




export interface API42063Req {
  
  /** 手机号 */
  userPhone?: string;
  /** 用户登录密码 */
  userPasswd?: string;
  /** 前端滑块验证通过返回的sessionId */
  sessionId?: string;
  /** 前端滑块验证通过返回的sig */
  sig?: string;
  /** 前端滑块验证通过返回的token */
  sToken?: string;
  /** 场景标识 */
  scene?: string;
};



export interface API42063Res {
  /** 是否切换为新平台  */
  isNewPlatform?: boolean;
  /** 用户id  */
  userId?: string;
  /** 用户的钉钉userId  */
  dingdingUserId?: string;
  /** 钉钉用户的头像地址  */
  dingdingHeadIconUrl?: string;
  /** 业务id  */
  userName?: string;
  /** 备注  */
  remark?: string;
  /** 邮箱  */
  userEmail?: string;
  /** 用户登录token  */
  userToken?: string;
  /** 是否灰度用户  */
  isBeta?: boolean;
  /** 是否需要重置密码  */
  needReset?: boolean;
  /** 是否服务灰度  */
  isGray?: boolean;
  /** 宕机起始时间  */
  breakDownStart?: string;
  /** 宕机截止时间  */
  breakDownEnd?: string;
  /** 宕机内容  */
  breakMessage?: string;
  
};


// 42063 用户滑块登录

export interface IUsePostAPI42063Return {
  /** 用户滑块登录: 接口请求状态 */
  isAPI42063Loading: boolean;
  /** 用户滑块登录: 接口请求返回数据 */
  dataAPI42063: API42063Res;
  /**  用户滑块登录: 接口数据请求方法 */
  fetchAPI42063Data:  (inputs: API42063Req, config?: YWRequestConfig) => Promise<API42063Res>;
  /** 用户滑块登录: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI42063 = ():IUsePostAPI42063Return => {
  let isMount = true;
  const [isAPI42063Loading, setIsAPI42063Loading] = useState(false);
  const [dataAPI42063, setDataAPI42063] = useState<API42063Res>({} as API42063Res);
  const requestUrl = `${basePath}/ywwl-admin/user/slider/login`;

  const fetchAPI42063Data = async (inputs: API42063Req, config?: YWRequestConfig): Promise<API42063Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API42063Req>) || {}) as API42063Req;
    
  
    if ( isMount ) {
      setIsAPI42063Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API42063Res>(`${basePath}/ywwl-admin/user/slider/login`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI42063(res || {} as API42063Res);
        setIsAPI42063Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI42063Loading(false);
      }
      return false as unknown as API42063Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI42063Loading,
    dataAPI42063,
    fetchAPI42063Data,
    requestUrl,
  }
}

